module.exports = __webpack_public_path__ + "media/images/emoticons/up-168f961f8a38cbe8a354b86ea0810e38.gif";